import { create } from 'zustand';
import { toast } from 'react-toastify';
import { TOAST_MESSAGE_CSS } from 'modules/utilities/utility';
import { downloadCovinReport, getCovinData } from '../api_layer/api';

export const useCovinDashboard = create((set) => ({
  covinData: [],
  covinLoading:false,
  fetchCovinData: async (startDate, endDate, page) => {
    try {
      set({ isError: true, covinLoading: true });
      const response = await getCovinData(startDate, endDate, page);
      set({ covinData: response.data, covinLoading: false });
    } catch (error) {
      set({ isError: true, covinLoading: false });
      toast.error(error?.response?.data?.message, TOAST_MESSAGE_CSS);
    }
  },
  downloadCovinReport: async (startDate, endDate) => {
    try {
      await downloadCovinReport(startDate, endDate);
      toast.success("Email sent successfully", TOAST_MESSAGE_CSS);
    } catch (error) {
      toast.error(error?.response?.data?.message, TOAST_MESSAGE_CSS);
    }
  },
}));
